import { Inject, inject, Injectable, PLATFORM_ID } from "@angular/core";
import { Observable, map, of } from "rxjs";
import { environment } from "../../../environments/environment";
import { Addon, StmxCommonCacheService } from "ngx-exdr-stmx-common";
import { DOCUMENT, isPlatformServer, PlatformLocation } from "@angular/common";
import { HttpClient } from "@angular/common/http";


@Injectable({
    providedIn: "root"
})
export class AddonService {
    constructor(
        private cacheService: StmxCommonCacheService,
        @Inject(DOCUMENT) private document: Document,
        private http: HttpClient,
        @Inject(PLATFORM_ID) private platformId: string
    ) {

    }

    /**
    * Gets Addons from /api/group/${groupId}/addon by making HTTP call.
    *
    * @param groupsId Group ID to get addons for that group.
    *
    * @returns Observable of addons array - Need to implement type safety.
    */
    getAddons(groupId: string): Observable<Addon[]> {      
      const url = `${environment.apiHost}/api/group/${groupId}/addon`;  
      let request$: Observable<Addon[]>;

      request$ = this.http.get<any>(url);                        

      return request$.pipe(
        map((addons: any[]) => {
          return addons;
        })
      );
    }   

    
      

    /**
     * Gets addons on basis of type from getAddons method.
     * @param groupId 
     * @param addonType 
     * @returns 
     */
    getAddonByType(groupId: string, addonType: string): Observable<Addon | undefined> {
        return this.getAddons(groupId)
            .pipe(
                map((addons: Addon[]) => {
                    return addons.find(addon => addon.Type === addonType);
                })
            );
    }
}